import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./userSlice";
import DashboardData from "./Api/DashboardData";
import userManagement from "./Api/userManagement";
import roleManagement from "./Api/roleManagement";
import getQuotationData from "./Api/QuotationData";
import getContractData from "./Api/ContractData";
import getProjectData from "./Api/ProjectData";
import getClientData from "./Api/clientData";
import getBorderData from "./Api/boderData";
import getNationlityData from "./Api/clientData";
import getRateCategory from "./Api/RateCategory";
import getTermsData from "./Api/TermsData";
import getNotesData from "./Api/notesData";
import toggleSwitch from "./arrivalNotification";
import getVisaRequestData from "./Api/visarequestformApi";
import getVisaAllocation from "./Api/visaStockAPI";
import getProjectsByVisaId from "./Api/projectByVisaApi";
import getVrrData from "./Api/vrrData";
import getVisasummaryData from "./Api/visaStocksummaryAPI";
import getLocalTrasferData from "./Api/localtransfer";
import getVisscostandsecdeposite from "./Api/visacostandscdepositeAPI";
import getMasterData from "./Api/masterData";
import getInsuranceData from "./Api/InsuranceData";
import getFinInsuranceData from "./Api/FinInsuranceData";
import getSadaadData from "./Api/SadaadGetData";
import getIqamaData from "./Api/IqamaUpdateData";
import getAbsherData from "./Api/AbsherData";
import getATMData from "./Api/AtmPayRollData";
import getFinAtmData from "./Api/FinAtm"
import getQiwaContractData from "./Api/QiwaContractData";
import getQiwaContractRenewData from "./Api/QiwaContractDataRenew";
import getAjeerData from "./Api/AjeerData";
import getBaladiyaData from "./Api/BaladiyaData";
import getVisaProfessionChnagesData from "./Api/VisaProfessionChangesData";
import getDrivingData from "./Api/DrivingLicienceData";
import getAjeerRenewData from "./Api/AjeerRenew";
import getNakaLaData from "./Api/NakalakafalaData";
import getPassportData from "./Api/PassportData";
import getFinSadaad from "./Api/Finsadaad";
import getloanAdvanceData from "./Api/loanAdvanceAPI";
import getPayRoll from "./Api/FinPayRoll";
import getInvoicecostplusData from "./Api/InvoiceCostplusAPI";
import getOnarrivalmedicalData from "./Api/OnArrival";
import getFinOnArrivalData from "./Api/FinanceOnArrivalMedical";
import getFinAjeerData from "./Api/Finajeer";
import getGrAjeerData from "./Api/GRAjeer";
import getFinBaladiyaData from "./Api/FinBaladiya";
import getFinDrivingData from "./Api/FinDrivingLicienceData";
import getprojectInchargeSummary from "./Api/projectInchargeSummaryAPI";
import getemployeemobilizationData from "./Api/mobilizationAPI";
import getInsuranceDependentData  from "./Api/InsuranceDependent";
import getDependentSummary from "./Api/dependentSummary";
import dependentMaster from "./Api/dependentMaster";
import getDrivingRenewData from "./Api/DrivingLicienceData";
import getMobilization from "./Api/MobilizationData";
import getDeMobilizationNew from "./Api/demobilization";
import getBaladiyaRenewData from "./Api/BaladiyaRenew";
import getDemobilization from "./Api/DemobilizationData";

import getAtmDetails from './Api/AtmPayrollDetails'

export const store = configureStore({
  reducer: {
    user: userSlice,
    dashboardData: DashboardData,
    userManagement: userManagement,
    roleManagement: roleManagement,
    quotationData: getQuotationData,
    contractData: getContractData,
    visaRequestData : getVisaRequestData,
    visaAllocationSummay : getVisaAllocation,
    projectData: getProjectData,
    clientData: getClientData,
    boderData: getBorderData,
    nationalityData: getNationlityData,
    rateCategoryData: getRateCategory,
    termsData: getTermsData,
    notesData: getNotesData,
    updateArrival: toggleSwitch,
    projectsByVisaData : getProjectsByVisaId,
    VisareturnData : getVrrData,
    visaSummaryData : getVisasummaryData,
    localTrasferData : getLocalTrasferData,
    visacostsecDeposite : getVisscostandsecdeposite,
    masterData: getMasterData,
    insuranceData: getInsuranceData,
    finInsuranceData: getFinInsuranceData,
    sadaadData: getSadaadData,
    iqamaData: getIqamaData,
    absher: getAbsherData,
    atmData: getATMData,
    getFinAtm: getFinAtmData,
    qiwaData: getQiwaContractData,
    qiwaDataRenew: getQiwaContractRenewData,
    ajeerData: getAjeerData,
    baladiyaData: getBaladiyaData,
    visaProfessionChnages: getVisaProfessionChnagesData,
    drivingData: getDrivingData,
    nakaLaData: getNakaLaData,
    passportData: getPassportData,
    finSadaad: getFinSadaad,
    loanAdvanceData : getloanAdvanceData,
    finPayRoll: getPayRoll,
    Invoicecostplus : getInvoicecostplusData,
    onArrivalData: getOnarrivalmedicalData,
    finOnArrivalData: getFinOnArrivalData,
    finAjeer: getFinAjeerData,
    grAjeer: getGrAjeerData,
    finBaladiya: getFinBaladiyaData,
    finDrivingData: getFinDrivingData,
    projectInchargeData : getprojectInchargeSummary,
    employeeMobilization : getemployeemobilizationData,
    insuranceDependentData:getInsuranceDependentData,
    // insuranceDependentData: getInsuranceDependentData,
    insuranceDependentData: getInsuranceDependentData,
    dependentSummaryData: getDependentSummary,
    dependentMasterSummary: dependentMaster,
    drivingRenewData: getDrivingRenewData,
    mobilization: getMobilization,
    demobilization: getDeMobilizationNew,
    getAtmDetails: getAtmDetails,
    AjeerRenew : getAjeerRenewData,
    BaladiyaRenew : getBaladiyaRenewData
  },
});
